module.exports = __webpack_public_path__ + "media/images/members/anne_cayuela-3ebbeed9b9ce592df1d3d96bebe33dde.jpg";